import PropTypes from 'prop-types';

function ResultSearchSimple({
  keyword,
  total,
  selectedCategories,
  showClearButton,
  handleClearFilters,
  displayInfo,
}) {
  const showKeyword = displayInfo === 'keyword' && !!keyword;
  const showCategories =
    displayInfo === 'categories' && selectedCategories.length;

  return (
    <div className="result-search-simple">
      <div className="result-search-simple__search-info">
        {showCategories ? (
          <div className="result-search-simple__filters">
            Filtros:{' '}
            {selectedCategories.map(category => (
              <span
                key={category}
                className="result-search-simple__filter-name"
              >
                {category}
              </span>
            ))}
          </div>
        ) : null}

        {showKeyword ? (
          <div className="result-search-simple__keyword-container">
            <span className="result-search-simple__keyword-label">
              Buscando por:{' '}
            </span>
            <span className="result-search-simple__keyword">{keyword}</span>
          </div>
        ) : null}

        {showClearButton && (
          <button
            type="button"
            className="result-search-simple__filter-cleaner"
            onClick={handleClearFilters}
          >
            Limpar filtros
          </button>
        )}
      </div>

      <div className="result-search-simple__total-results">
        <span className="result-search-simple__total">{total}</span>{' '}
        {total === 1 ? 'resultado encontrado' : 'resultados encontrados'}
      </div>
    </div>
  );
}

ResultSearchSimple.propTypes = {
  keyword: PropTypes.string,
  total: PropTypes.number,
  selectedCategories: PropTypes.arrayOf(PropTypes.string),
  showClearButton: PropTypes.bool,
  handleClearFilters: PropTypes.func,
  displayInfo: PropTypes.string,
};

ResultSearchSimple.defaultProps = {
  showClearButton: false,
};

export default ResultSearchSimple;
